/**
 * テーブルバージョン管理（mst001）テーブル操作用メソッド 
 */

// メモった！、キニッタ！共通メソッド
import * as GVar from '@/components/00/Var00';                  // 共通変数
import * as Tools from '@/components/00/Tools';                 // 共通ツール
import * as GFunc from '@/components/00/Common00';            // 共通メソッド
import * as TableDef from '@/components/00/db/TableDef';

/**
 * mst001テーブル新規作成
 */
// export const create = async () =>
export const create = async function()
{
        if ( GFunc.isDebugEnabled() ) {console.log("mst001 create()");}
        try
        {
                // テーブル新規作成
                const resp = await GVar.db!.run("CREATE TABLE IF NOT EXISTS mst001 (tbl_id text, ver_no, upd_ts text, PRIMARY KEY (tbl_id));");
                // 全テーブルをバージョン管理に加える
                for ( const tableId in  TableDef.mstTables )
                {
                        await GVar.db!.run('insert into mst001 (tbl_id, ver_no, upd_ts) VALUES (?,?,?)', [tableId, TableDef.mstTables[tableId]["ver"], Tools.getCurrentYyyymmddhhmmss()]);
                }
                if ( GFunc.isDebugEnabled() ) {console.log("mst001テーブルを作成しました。", resp);}
        }
        catch(e)
        {
                console.log(GVar.sqliteErrorMsg+"mst001テーブルの作成に失敗しました。："+`${e}`);
        }
}
/**
 * Mst001のテーブルバージョンNo.を更新する
 *
 * @param tableId ターブル名
 */
export const updateTabelVersionNo = async function(tableId: string)
{
        if ( GFunc.isDebugEnabled() ) { console.log("updateTabelVersionNo() "+tableId); }
        try
        {
                let result;
                result = await GVar.db!.query("select count(*) from mst001 where tbl_id=?", [tableId]);
                if ( result.values![0].cnt == 0 )
                {
                        // バージョン情報が存在しないので作成する
                        if ( GFunc.isDebugEnabled() ) { console.log(tableId+" バージョン情報が存在しないので作成する"); }
                        result = await GVar.db!.run('insert into mst001 (tbl_id, ver_no, upd_ts) VALUES (?,?,?)', [tableId, TableDef.mstTables[tableId]["ver"] , Tools.getCurrentYyyymmddhhmmss()]);
                
                }
                else
                {
                        // バージョン情報が存在するので更新する
                        if ( GFunc.isDebugEnabled() ) { console.log(tableId+" バージョン情報が存在するので更新する"); }
                        result = await GVar.db!.run('update mst001 set ver_no=?, upd_ts=? where tbl_id=?', [TableDef.mstTables[tableId]["ver"], Tools.getCurrentYyyymmddhhmmss(), tableId]);
                }
        }
        catch(e)
        {
                console.log(GVar.sqliteErrorMsg+tableId+"テーブルのバージョン情報更新に失敗しました。："+`${e}`);
        }
}